__turbopack_context__.v({
  "breakdown": "style-module-scss-module__-Vf-iG__breakdown",
  "copyright": "style-module-scss-module__-Vf-iG__copyright",
  "cta": "style-module-scss-module__-Vf-iG__cta",
  "ctaButton": "style-module-scss-module__-Vf-iG__ctaButton",
  "ctaButtonLabel": "style-module-scss-module__-Vf-iG__ctaButtonLabel",
  "ctaButtonWrapper": "style-module-scss-module__-Vf-iG__ctaButtonWrapper",
  "ctaContent": "style-module-scss-module__-Vf-iG__ctaContent",
  "ctaDescription": "style-module-scss-module__-Vf-iG__ctaDescription",
  "ctaImage": "style-module-scss-module__-Vf-iG__ctaImage",
  "ctaMedia": "style-module-scss-module__-Vf-iG__ctaMedia",
  "ctaTitle": "style-module-scss-module__-Vf-iG__ctaTitle",
  "ctaVideo": "style-module-scss-module__-Vf-iG__ctaVideo",
  "cursorGlow": "style-module-scss-module__-Vf-iG__cursorGlow",
  "description": "style-module-scss-module__-Vf-iG__description",
  "eyebrow": "style-module-scss-module__-Vf-iG__eyebrow",
  "hero": "style-module-scss-module__-Vf-iG__hero",
  "heroContent": "style-module-scss-module__-Vf-iG__heroContent",
  "heroWave": "style-module-scss-module__-Vf-iG__heroWave",
  "pageFooter": "style-module-scss-module__-Vf-iG__pageFooter",
  "scoreBar": "style-module-scss-module__-Vf-iG__scoreBar",
  "signals": "style-module-scss-module__-Vf-iG__signals",
  "socialLink": "style-module-scss-module__-Vf-iG__socialLink",
  "socials": "style-module-scss-module__-Vf-iG__socials",
  "title": "style-module-scss-module__-Vf-iG__title",
});
